import {Component, Input, OnInit} from "@angular/core";
import {ConfService} from "../../conf.service";
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

declare let $;
@Component({
    selector: 'response-map',
    templateUrl: './response-map.component.html',
    styleUrls: ['./response-map.component.css']
})
export class ResponseMapComponent implements OnInit {
    panelOpenState = false;
    executors: any;
    partner: string;
    account: string;
  //  config = {};
    responseSelected: string;
  //  responseAttributes= [];
    @Input() newData: any;
    @Input() responseAttributes: any;
    @Input() config: any;
    attributes = ['Status', 'Status Message'];
    operations = {
        "operation_name":"gettestexecutorapimodel1",
        "display_name":"Fetch records",
        "description":"Gets all the records from entity : testexecutorapimodel1",
        "operation_type":"GET",
        "url":"v1/data/salapi/salapi/testexecutorapimodel1",
        "collection_name":"testexecutorapimodel1",
        "parameters":[
            {
                "type":"query",
                "annotation":"RequestParam",
                "name":"query",
                "description":"Query based on attribute values",
                "required":false,
                "allowReserved":false,
                "deprecated":false,
                "schema":{
                    "type":"String"
                }
            },
            {
                "type":"header",
                "annotation":"RequestHeader",
                "name":"pkey",
                "description":"Partner Key",
                "required":true,
                "allowReserved":false,
                "deprecated":false,
                "schema":{
                    "type":"String"
                }
            }
        ],
        "authModel":null,
        "prerequisites":null,
        "notes":null
    };
    constructor(private confPost: ConfService, public platform: LeftpanelComponent) {}
    ngOnInit(): void {
        this.partner = localStorage.getItem('partner');
        this.account = localStorage.getItem('account');

        if (this.platform.partnerExecutors !== null && this.platform.partnerExecutors !== undefined) {
            this.executors = this.platform.partnerExecutors;
            return this.executors;
        } else {
            this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'))
                .toPromise().then(data => {
                    this.executors = data;
                    this.platform.partnerExecutors = data;
                    return data;
                });
        }
        //
        // this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'))
        //     .subscribe(data => {
        //         this.executors = data;
        //     });
    }
    toggle(ev){
        // ev.target.click(function(){
        $(ev.target).parent('td').closest('tr').siblings().toggle();
        $(ev.target).toggleClass("fa-angle-double-down fa-angle-double-up");
        // });
    }
    deleteExecutor(data, i){
        const index: number = i;
        if (index !== -1) {
            data.splice(index, 1);
        }
        return data;
    }
    allowDrop(ev) {
        ev.preventDefault();
    }

    drag(ev) {
        ev.dataTransfer.setData("text", ev.target.id);
    }
    newDrop(newdata, ev) {

        var that = this;
        var data = ev.dataTransfer.getData("text");
        var text = document.getElementById(data).innerHTML;
        let addData;
        if(text.trim() == 'If else If') {
            addData = {
                "executor_name": "IfConditionSample",
                "executor_type": "ControlFlow",
                "control_flow_type": "If",
                "control_flow": [{
                    "control_type": "If",
                    "conditions": {
                        condition: "and",
                        rules: [
                        ]
                    },
                    "executors": [
                    ]

                },
                    {
                        "control_type": "Else If",
                        "conditions": {
                            condition: "and",
                            rules: [
                            ]
                        },
                        "executors": [
                        ]
                    }
                ]
            };
        } else if(text.trim() == 'Switch') {
            addData = {
                "executor_name": "SwitchConditionSample",
                "executor_type": "ControlFlow",
                "control_flow_type": "Switch",
                "control_flow": [{
                    "control_type": "Switch",
                    "conditions": {
                        condition: "and",
                        rules: [
                        ]
                    },
                    "executors": [
                    ]

                },
                    {
                        "control_type": "Case",
                        "conditions": {
                            condition: "and",
                            rules: [
                            ]
                        },
                        "executors": [
                        ]
                    },
                    {
                        "control_type": "Default",
                        "conditions": {
                            condition: "and",
                            rules: [
                            ]
                        },
                        "executors": [
                        ]

                    }
                ]
            };
        } else {
            const category = that.getCat(data);
            const fdata = this.executors[category].executors.findIndex(p => p && p.executor_name === text.trim());
            addData = this.executors[category].executors[fdata];
            addData.mapping = [{"key": null, "value": null}];
            addData.crAttributes = [];
            addData.responseAttributes.forEach((attr) => {
                if(attr != 'undefined' || attr != null) {
                    that.getNodeAttributes(addData.executor_name, attr);
                    that.getAttr(addData.crAttributes, attr);
                }
            });
        }
        return newdata.push(addData);
    }

    getNodeAttributes(exName, data) {
        const that = this;
        if(data.subType == null) {
            this.responseAttributes.push(exName +'.'+data.attributeName);
            this.config[exName +'.'+data.attributeName]
                = {name: exName +'.'+data.attributeName , type:
                    (data.type.toLowerCase() == 'integer' ? 'number' :
                        (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
        } else {
            data.subType.forEach((sub) => {
                if(sub.subType == null) {
                    this.responseAttributes.push(exName +'.'+data.attributeName + '.' + sub.attributeName);
                    this.config[exName +'.'+data.attributeName + '.' + sub.attributeName]
                        = {name: exName +'.'+data.attributeName + '.' + sub.attributeName , type:
                            (data.type.toLowerCase() == 'integer' ? 'number' :
                                (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
                } else {
                    that.getLeafAttributes(exName +'.'+data.attributeName, sub);
                }
            });
        }
    }
    getLeafAttributes(parent, data) {
        const that = this;
        if(data.subType == null) {
            this.responseAttributes.push(parent + '.' + data.attributeName);
            this.config[parent + '.' + data.attributeName]
                = {name: parent + '.' + data.attributeName , type:
                    (data.type.toLowerCase() == 'integer' ? 'number' :
                        (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
        } else {
            data.subType.forEach((sub) => {
                if(sub.subType == null) {
                    this.responseAttributes.push(parent + '.' +data.attributeName + '.' + sub.attributeName);
                    this.config[parent + '.' +data.attributeName + '.' + sub.attributeName]
                        = {name: parent + '.' +data.attributeName + '.' + sub.attributeName , type:
                            (data.type.toLowerCase() == 'integer' ? 'number' :
                                (data.type.toLowerCase() == 'boolean' ? 'boolean' : 'string')) };
                } else {
                    that.getLeafAttributes(parent + '.' +data.attributeName, sub);
                }
            });
        }
    }
    getAttr(parent, data) {
        const that = this;
        let responseAttributes = [];
        if(data.subType == null) {
            parent.push(data.attributeName);
        } else {
            data.subType.forEach((sub) => {
                if(sub.subType == null) {
                    parent.push(data.attributeName + '.' + sub.attributeName);
                } else {
                    that.leafattr(parent, data.attributeName, sub);
                }
            });
        }
    }
    leafattr(p, parent, data){
        const that = this;
        if(data.subType == null) {
            p.push(parent + '.' + data.attributeName);
        } else {
            data.subType.forEach((sub) => {
                if(sub.subType == null) {
                    p.push(parent + '.' +data.attributeName + '.' + sub.attributeName);
                } else {
                    that.leafattr(p,parent + '.' +data.attributeName, sub);
                }
            });
        }
    }
    addRules(data, i){
        data.push(data[0]);
    }
    removeRules(data, i){
        const index: number = i;
        if (index !== -1) {
            data.splice(index, 1);
        }
    }
    addCfSub(type, data) {
        let datacfl;
        if(type == 'If') {
            datacfl = {
                "control_type": "Else If",
                "conditions": {
                    condition: "and",
                    rules: [
                    ]
                },
                "executors": [
                ]
            };
            data.push(datacfl);
        } else if (type == 'Switch'){
            datacfl = {
                "control_type": "Case",
                "conditions": {
                    condition: "and",
                    rules: [
                    ]
                },
                "executors": [
                ]
            };
            data.splice( 1, 0,datacfl);
        }
    }
    executorToggle(ev) {
        $(ev.target).parent('.category').next('.items').toggle();
        $(ev.target).toggleClass("fa-angle-double-right fa-angle-double-down");
    }
    getCat(val){
        const result = val.split('_');
        return result[0];
    }
    stringifyjson(val) {
        return JSON.stringify(val, null, 2).trim();
    }
    addMapping(data) {
        const map = {"key": null, "value": null};
        data.push(map);
    }
    removeMapping(data, index) {
        if (index !== -1) {
            data.splice(index, 1);
        }
    }
}
